import React, { useState } from 'react';
import {
  Card,
  CardContent,
  TextField,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../../redux/slices/notificationSlice';
import CustomButton from '../../../componentsII/Buttons';
import api from '../../../axios/api';

const AddUpdateNaturalGasTypeModal = ({ onClose, refetch, gasId = null, initialData = null }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  // Form state
  const [formData, setFormData] = useState({
    gasName: initialData?.nat_gas_name || '',
    formula: initialData?.formula || '',
  });

  const validate = (values) => {
    const newErrors = {};

    // Gas Name validation
    if (!values.gasName.trim()) {
      newErrors.gasName = 'Natural Gas name is required';
    } else if (values.gasName.length < 2) {
      newErrors.gasName = 'Natural Gas name must be at least 2 characters';
    }

    // Formula validation
    if (!values.formula.trim()) {
      newErrors.formula = 'Formula is required';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        gasId: gasId || 0,
        ...formData
      };
      const response = await api.post('/admin/CreateUpdateNaturalGas', payload);
      if (response.data.status == '200') {
        dispatch(showNotification({
          message: response.data.message,
          type: "success"
        }));
        onClose();
        refetch?.();
      } else {
        setErrors(prev => ({
          ...prev,
          general: response.data.message || 'Something went wrong'
        }));
      }

      onClose();
      refetch?.();
    } catch (error) {
      setErrors({ submit: error.message });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <Card className="w-full mx-auto">
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <label htmlFor="gasName" className="text-sm font-medium">
              Natural Gas Name
            </label>
            <TextField
              size="small"
              id="gasName"
              name="gasName"
              value={formData.gasName}
              onChange={handleInputChange}
              placeholder="Enter natural gas name"
              disabled={isSubmitting}
              error={Boolean(errors.gasName)}
              className={'w-full'}
            />
            {errors.gasName && (
              <p className="text-sm text-red-500 mt-1">{errors.gasName}</p>
            )}
          </div>

          <div className="space-y-2">
            <label htmlFor="formula" className="text-sm font-medium block">Formula</label>
            <TextField
              size='small'
              id="formula"
              name="formula"
              value={formData.formula}
              onChange={handleInputChange}
              placeholder="Enter chemical formula"
              disabled={isSubmitting}
              error={Boolean(errors.formula)}
              className={'w-full'}
            />
            {errors.formula && (
              <p className="text-sm text-red-500 mt-1">{errors.formula}</p>
            )}
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <CustomButton
              className="bg-gray-500 hover:bg-gray-700 text-white"
              text="Cancel"
              click={onClose}
            />
            <CustomButton
              className="bg-green-600 hover:bg-green-700 text-white"
              text={gasId ? "Update" : "Submit"}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default AddUpdateNaturalGasTypeModal;